module.exports = __webpack_public_path__ + "static/collins-896726cd36576dacdcc7805c0a662684.jpeg";